export default function generateReturnURL(redirectLinks: string[]) {
  if (!redirectLinks.length) {
    return '';
  }

  let returnURL = redirectLinks.pop() as string;

  redirectLinks.reverse();
  redirectLinks.forEach((link, i) => {
    returnURL = `${link}?returnURL=${encodeURIComponent(returnURL)}`;
  });
  returnURL = `?returnURL=${encodeURIComponent(returnURL)}`;

  return returnURL;
}
